<script setup>
import { ref, computed } from 'vue';
import UploadBox from '@/components/preview/chat/Upload.vue';
import AddMaterialAssetPicker from '@/components/create/AddMaterialAssetPicker.vue';

const props = defineProps({
  type: {
    type: String,
    required: true, // 'reference', 'material', 'document'
  },
  title: String,
  description: String,
  accept: String,
  uploading: Boolean,
  progress: Number,
  multiple: Boolean,
  pickerType: String, // 'ref', 'document', or undefined
});

const emit = defineEmits(['upload', 'pick']);
const assetPicker = ref(null);

function onUpload(files) {
  emit('upload', files);
}

function onPick(asset) {
  emit('pick', asset);
}

function flush() {
  assetPicker.value?.flush();
}

const uploadBoxType = computed(() => {
  if (props.type === 'reference') return 'ref';
  return props.type;
});

defineExpose({ flush });
</script>

<template>
  <div class="space-y-2">
    <UploadBox
      :type="uploadBoxType"
      :title="title"
      :description="description"
      :accept="accept"
      :uploading="uploading"
      :progress="progress"
      :multiple="multiple"
      @file="onUpload"
    />
    <slot name="extra"></slot>
    <AddMaterialAssetPicker ref="assetPicker" :type="pickerType" @pick="onPick" />
  </div>
</template>
